// src/service/Api.js
import axios from "axios";

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const api = axios.create({
  baseURL: "https://api.erpsaude.com.br/v2/",
  timeout: 25000,
});

api.interceptors.response.use(
  response => response, // passa se sucesso
  async error => {
    const config = error.config;
    if (!config) {
      return Promise.reject(error);
    }
    config.__retryCount = config.__retryCount || 0;
    const status = error.response?.status;
    const shouldRetry =
      (!status || (status >= 500 && status < 600)) &&
      config.__retryCount < 3;
    if (shouldRetry) {
      config.__retryCount += 1;
      console.warn(
        `[API RETRY] Tentativa ${config.__retryCount} após erro ${status || "NETWORK"
        }...`
      );
      await sleep(2000);
      return api(config);
    }
    return Promise.reject(error);
  }
);

export const api_host = axios.create({
  baseURL: "https://api.erpsaude.com.br/v2/",
});

export const create = async (login, senha) => {
  try {
    const response = await api.get(`Usuario/Login?login=${login}&senha=${senha}`);
    return response.data;
  } catch (err) {
    console.error("Erro ao tentar logar:", err);
    throw err;
  }
};
